<template>
  <main role="main" class="main bg-navy">
    <div class="bg-navy d-block d-md-none">
      <b-row class="no-gutters">
        <b-col class="text-center">
          <b-button type="button" variant="link" class="color-white float-left py-3" to="/home">
            <feather type="arrow-left"></feather>
          </b-button>
          <span class="d-inline-block h-100 title-w-60">
            <span class="d-table h-100">
              <span class="d-table-cell align-middle">
                <strong class="color-white">Registration Status</strong>
              </span>
            </span>
          </span>
        </b-col>
      </b-row>
    </div>
    <div class="mobile-vh h-md-100 p-4 p-md-5 bg-white mobi-rounded-top">
      <b-row class="custom-height">
        <b-col lg="9" offset-lg="1">
          <profile-menu></profile-menu>
          <h2 class="mobile-size-reduce color-navy-blue mb-3">Registration Status</h2>
          <div v-if="userStatus === 'loaded'">
            <p class="color-grey mb-4 complete" v-for="tick in status" :key="tick.name">
              <feather v-if="tick.status == 'Verified' || tick.status === 'Failed'" :type="tick.status === 'Verified' ? 'check' : 'x'" class="float-right mr-2"></feather>
              <strong class="font-size-20 mobile-size-reduce">{{ tick.name.replace(' Verification', '') }}</strong><br />
              {{ tick.comments || 'We\'re busy verifying your details' }}
            </p>
          </div>
          <b-form-group class="btn-bottom">
            <b-row>
              <b-col md="6">
                <b-button variant="outline-custom" pill block class="mt-3" href="tel://+27114860692">
                  Call us
                  <feather type="phone"></feather>
                </b-button>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </main>
</template>

<script>
import ProfileMenu from '@/components/organisation/ProfileMenu'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    ProfileMenu
  },
  data () {
    return {
      validated: null,
      status: [],
      validation_message: null
    }
  },
  computed: {
    ...mapState({
      userStore: state => state.user
    }),
    user () {
      return this.userStore.user
    },
    userStatus () {
      return this.userStore.status
    }
  },
  methods: {
    ...mapActions('user', ['get'])
  },
  created () {
    this.get()
  },
  watch: {
    userStatus: function (value) {
      if (value === 'loaded') {
        const _status = this.user.status
        let _verified = true
        if (_status.company && _status.company.length > 0) {
          _status.company.forEach(status => {
            if (status.status !== 'Verified' && _verified) {
              _verified = false
            }

            if (!_verified && !this.validation_message && status.status !== 'Not Yet Verified') {
              this.validation_message = status.name + ': ' + status.comments
            }

            this.status.push(status)
          })
        }

        this.validated = _verified
      }
    }
  }
}
</script>
